import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output } from '@angular/core';
import { ContentService, DcrKeyPipe } from '@blk/cwp-ng-framework';
import { DzGridConstants } from '@blk/daisy/util';
import { TealiumAnalyticsEvent, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';

import { ModelsExperienceDropdownFilters, ModelsExperienceFilters, ModelsExperienceFiltersOption } from '../../models';

@Component({
	selector: 'mb-models-experience-dropdown',
	templateUrl: './dropdown.component.html',
	styleUrls: ['./dropdown.component.scss']
})
export class ModelsExperienceDropdownComponent implements OnChanges {

	@Input() public filter: ModelsExperienceDropdownFilters;
	@Output() public getSelectedFilters: EventEmitter<ModelsExperienceFilters> = new EventEmitter<ModelsExperienceFilters>();
	public showDropDown = false;
	public displayText: string = 'Select one';
	public isMobile: boolean = window.innerWidth <= DzGridConstants.BREAKPOINTS.sm;
	public selectedFilter: ModelsExperienceFilters;
	public showMobileFilterErrorMsg: boolean = false;

	constructor(private elementRef: ElementRef, private contentService: ContentService, private tealiumAnalyticsService: TealiumAnalyticsService) { }

	@HostListener('document:click', ['$event'])
	public onClickOutsideTheDropdown(event: any): void {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.showDropDown = false;
		}
	}

	@HostListener('window:resize', ['$event'])
	private onResize(event): void {
		this.isMobile = event.target.innerWidth <= DzGridConstants.BREAKPOINTS.md;
	}

	public ngOnChanges(): void {
		this.selectedFilter = { ...this.filter, options: [] };
		this.setPreviousSelectedFilters();
	}

	public onFilterSelection(filterOption: ModelsExperienceFiltersOption): void {
		if (filterOption.selected) {
			this.selectedFilter.options.push(filterOption.optionId);
		} else {
			const index = this.selectedFilter.options.indexOf(filterOption.optionId);
			this.selectedFilter.options.splice(index, 1);
		}
		const eventName = TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME + ':' + TealiumConstants.MODELS_EXPERIENCE_EVENTS.FIND_AND_COMPARE_PAGE + `:dropdown filter:${this.selectedFilter.meFilterId}:${filterOption.optionId}:${filterOption.selected ? 'checked' : 'unchecked'}`;
		this.tealiumAnalyticsService.trackEventTealium(new TealiumAnalyticsEvent(eventName, { toolName: TealiumConstants.TOOL_NAMES.MODELS_EXPERIENCE }));

		this.getDisplayText();
		this.getSelectedFilters.emit(this.selectedFilter);
	}

	public setPreviousSelectedFilters(): void {
		this.selectedFilter.options = this.filter.options.filter((option) => option.selected).map(option => option.optionId);
		this.getDisplayText();
	}

	public getDisplayText(): void {
		if (this.selectedFilter?.options.length === 1) {
			this.displayText = this.contentService.get(new DcrKeyPipe().transform('FILTEROPT_' + this.selectedFilter.options[0]), this.selectedFilter.options[0]);
		} else if (this.selectedFilter.options.length > 1) {
			this.displayText = this.selectedFilter.options.length + ' Selections';
		} else {
			this.displayText = 'Select one';
		}
	}

	public showDropdownFilter(): void {
		if (this.isMobile && this.filter.applicability === 'portfolio') {
			this.showDropDown = false;
			this.showMobileFilterErrorMsg = true;
		} else {
			this.showDropDown = !this.showDropDown;
		}
	}
}
